import React, { useState } from 'react';
import LoginSignupLayout from '../../componants/LoginSignupLayout';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import img from '../../assets/login.png';
import img1 from '../../assets/side.png';

const AuthPage: React.FC = () => {
  const [userType, setUserType] = useState<'buyer' | 'seller'>('buyer');
  const [isFlipped, setIsFlipped] = useState(false);

  const isSeller = userType === 'seller';
  const illustration = isSeller ? img : img1;

  return (
    <div className="fixed inset-0 z-50 w-screen h-screen bg-white overflow-hidden font-sans select-none">
      
      {/* =====================================================================================
          TABLET & DESKTOP VIEW (md: 768px onwards)
          ===================================================================================== */}
      <div className="hidden md:block absolute inset-0 w-full h-full">
          
          {/* --- MOVING GREEN PANEL --- */}
          <div 
            className="absolute top-0 bottom-0 h-full bg-emerald-600 transition-all duration-1000 ease-[cubic-bezier(0.68,-0.55,0.27,1.55)] z-20 flex flex-col justify-center items-center text-white" 
            style={{
                width: '50%', // iPad par balance ke liye width 50% ki hai
                left: isSeller ? '50%' : '0%',
                filter: 'drop-shadow(0px 10px 30px rgba(0,0,0,0.2))',
                maskImage: isSeller 
                    ? 'radial-gradient(ellipse 100px 75% at 0% 50%, transparent 99%, black 100%)'
                    : 'radial-gradient(ellipse 100px 75% at 100% 50%, transparent 99%, black 100%)',
                WebkitMaskImage: isSeller 
                    ? 'radial-gradient(ellipse 100px 75% at 0% 50%, transparent 99%, black 100%)' 
                    : 'radial-gradient(ellipse 100px 75% at 100% 50%, transparent 99%, black 100%)'
            }}
          >
              <div className="w-full text-center transition-all duration-700 animate-fade-in px-6 lg:px-12 flex flex-col items-center justify-center h-full">
                  {/* Text Size Clamp use kiya hai taaki iPad par text na kate */}
                  <h1 className="text-[clamp(1.8rem,4vw,3.5rem)] font-serif font-bold mb-4 drop-shadow-lg tracking-tight leading-[1.1]">
                      {isSeller ? 'Scale Your Business' : 'Welcome to Our Community'}
                  </h1>
                  
                  <p className="text-[clamp(0.9rem,1.5vw,1.125rem)] opacity-95 mb-6 font-light leading-relaxed max-w-[90%] mx-auto">
                      {isSeller 
                        ? 'Empower your enterprise with our advanced seller dashboard and real-time insights.' 
                        : 'Access exclusive deals and track your orders in a secure environment.'}
                  </p>

                  <img 
                    src={illustration} 
                    alt="illustration" 
                    className="w-full max-w-[320px] lg:max-w-[500px] xl:max-w-[580px] h-auto max-h-[40vh] object-contain drop-shadow-2xl"
                  />
              </div>
          </div>

          {/* --- FORM CONTAINERS --- */}
          <div className="absolute inset-0 w-full h-full flex">
              
              {/* Form Areas ki width 50% ki hai taaki split screen perfect dikhe */}
              <div className={`w-1/2 h-full flex items-center justify-center p-4 lg:p-10 transition-all duration-700 ${isSeller ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
                  <div className="w-full max-w-[360px] lg:max-w-[400px] xl:max-w-md bg-white p-2 rounded-[2.5rem] border-[6px] border-emerald-600 shadow-xl overflow-hidden">
                    <LoginSignupLayout currentUserType={userType} onUserTypeChange={setUserType}>
                        <AuthFormManager userType="seller" isFlipped={isFlipped} setIsFlipped={setIsFlipped} />
                    </LoginSignupLayout>
                  </div>
              </div>

              <div className={`w-1/2 h-full flex items-center justify-center p-4 lg:p-10 ml-auto transition-all duration-700 ${!isSeller ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
                  <div className="w-full max-w-[360px] lg:max-w-[400px] xl:max-w-md bg-white p-2 rounded-[2.5rem] border-[6px] border-emerald-600 shadow-xl overflow-hidden">
                    <LoginSignupLayout currentUserType={userType} onUserTypeChange={setUserType}>
                        <AuthFormManager userType="buyer" isFlipped={isFlipped} setIsFlipped={setIsFlipped} />
                    </LoginSignupLayout>
                  </div>
              </div>

          </div>
      </div>

      {/* =====================================================================================
          MOBILE VIEW (Below 768px)
          ===================================================================================== */}
      <div className="md:hidden w-full h-full bg-emerald-600 flex flex-col overflow-y-auto">
          <div className="relative w-full h-[25vh] shrink-0 flex flex-col items-center justify-center px-6 text-white text-center">
             <h1 className="text-3xl font-serif font-bold mb-1">Join Us Today</h1>
             <p className="text-sm opacity-80">Shop from thousands of products</p>
          </div>
          <div className="w-full px-4 pb-10 flex-grow">
             <div className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-[360px] mx-auto border-[6px] border-emerald-100 overflow-hidden">
                 <div className="p-2">
                    <LoginSignupLayout currentUserType={userType} onUserTypeChange={setUserType}>
                        <AuthFormManager userType={userType} isFlipped={isFlipped} setIsFlipped={setIsFlipped} />
                    </LoginSignupLayout>
                 </div>
             </div>
          </div>
      </div>

      <style>{`
        .backface-hidden { backface-visibility: hidden; }
        .rotate-y-180 { transform: rotateY(180deg); }
        .flipped { transform: rotateY(180deg); }
        .modal-flipper { transform-style: preserve-3d; perspective: 1000px; }
        @keyframes fadeIn { from { opacity: 0; transform: scale(0.98); } to { opacity: 1; transform: scale(1); } }
        .animate-fade-in { animation: fadeIn 0.6s ease-out forwards; }
      `}</style>
    </div>
  );
};

const AuthFormManager = ({ userType, isFlipped, setIsFlipped }: any) => {
    return (
        <div className={`modal-flipper relative w-full transition-transform duration-700 ${isFlipped ? 'flipped' : ''}`} style={{minHeight: '460px'}}>
            <div className="modal-front absolute inset-0 w-full backface-hidden bg-white">
                <LoginPage initialUserType={userType} onShowSignup={() => setIsFlipped(true)} />
            </div>
            <div className="modal-back absolute inset-0 w-full backface-hidden rotate-y-180 bg-white">
                <SignupPage initialUserType={userType} onShowLogin={() => setIsFlipped(false)} />
            </div>
        </div>
    );
};

export default AuthPage;